module.exports = __webpack_public_path__ + "img/b5.6b5a0bc5.jpg";